export const SDK_CDN_URL = `https://cdn.static.hsmoa.com/ok-sdk`;
